import React, { useMemo, useState } from 'react';
import { fill, matchesQuery } from './labels';
import HourRow from './HourRow';

// Replaces the old accordion. Search filters across every hour at once and hides slots
// with no match; only the current/most-recent hour is open by default.
export default function HourlyDetail({ hourlyData, defaultOpenHour, running, labels }) {
  var [query, setQuery] = useState('');
  var [openHours, setOpenHours] = useState(null);
  var [expandedRows, setExpandedRows] = useState({});

  var filtered = useMemo(function () {
    if (!query) return hourlyData || [];

    return (hourlyData || []).
      map(function (block) {
        var participants = block.participants.filter(function (participant) {
          return matchesQuery(participant, query);
        });
        return Object.assign({}, block, { participants: participants, count: participants.length });
      }).
      filter(function (block) { return block.count > 0; });
  }, [hourlyData, query]);

  // While searching every matching slot opens; otherwise the explicit set wins, and
  // before any interaction only the default hour is open.
  var openSet = useMemo(function () {
    if (query) {
      return filtered.reduce(function (set, block) {
        set[block.hour] = true;
        return set;
      }, {});
    }
    if (openHours) return openHours;
    var initial = {};
    if (defaultOpenHour !== null && defaultOpenHour !== undefined) initial[defaultOpenHour] = true;
    return initial;
  }, [query, filtered, openHours, defaultOpenHour]);

  var allOpen = filtered.length > 0 && filtered.every(function (block) { return openSet[block.hour]; });

  function toggleHour(hour) {
    setOpenHours(Object.assign({}, openSet, { [hour]: !openSet[hour] }));
  }

  function toggleAll() {
    if (allOpen) return setOpenHours({});
    return setOpenHours(filtered.reduce(function (set, block) {
      set[block.hour] = true;
      return set;
    }, {}));
  }

  var totalMatched = filtered.reduce(function (sum, block) { return sum + block.count; }, 0);

  return (
    <div className="card ehc-monitoring__card">
      <div className="card-header ehc-monitoring__card-header">
        <div>
          <span className="ehc-monitoring__eyebrow">{labels.eyebrow}</span>
          <p className="ehc-monitoring__sub">
            {query
              ? fill(labels.search_result, { count: totalMatched, query: query })
              : fill(labels.sub, { count: totalMatched, slots: filtered.length })}
          </p>
        </div>
        <div className="ehc-monitoring__toolbar-actions">
          <div className="form-group mb-0 ehc-monitoring__search">
            <input
              type="search"
              className="form-control"
              placeholder={labels.search_placeholder}
              value={query}
              onChange={function (event) { setQuery(event.target.value); }}
            />
            <i className="form-group__bar" />
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={toggleAll}>
            {allOpen ? labels.collapse_all : labels.expand_all}
          </button>
        </div>
      </div>

      <div className="card-body ehc-monitoring__hours">
        {filtered.map(function (block) {
          return (
            <HourRow
              key={block.hour}
              block={block}
              isOpen={Boolean(openSet[block.hour])}
              isExpandedRows={Boolean(expandedRows[block.hour])}
              onToggle={toggleHour}
              onShowAll={function (hour) {
                setExpandedRows(Object.assign({}, expandedRows, { [hour]: true }));
              }}
              labels={labels}
            />
          );
        })}

        {running > 0 && (
          <div className="ehc-monitoring__running">
            <i className="zmdi zmdi-time" />
            {fill(labels.running, { count: running })}
          </div>
        )}
      </div>
    </div>
  );
}
